const isDev = process.env.NODE_ENV === "development";

export const logger = {
  error: (...args) => isDev && logger.error(...args),
  warn: (...args) => isDev && console.warn(...args),
};
